export class StructureNode {

    stationGroupId: number;
    stationSetId: number;
    name: string;

    constructor(node: any) {
        this.stationGroupId = node.stationGroupId;
        this.stationSetId = node.stationSetId;
        this.name = node.name;
    }

}